import produce from 'immer'
import {
  COMPANIES_LOAD,
  COMPANIES_LOAD_SUCCESS,
  COMPANIES_LOAD_FAIL
} from './actions'

const initialState = {
  loading: false,
  error: null,
  data: {}
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case COMPANIES_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case COMPANIES_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.companies || {}
        return
      }
      case COMPANIES_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
